import { ColumnsType } from 'antd/lib/table';
import Flag from 'react-flagpack';
import { ErrorBoundary } from '../../../../components/index';
import { TrackingLogType } from '../../../../types';
import { createDateStringPtBr } from '../../../../utils/utils';

export type ColumnsFilterType = {
  text: string;
  value: string;
};

export function ChargeReportTableColumns(
  dataSource?: TrackingLogType[]
): ColumnsType<Record<string, any>> {
  return [
    {
      title: 'Atracação',
      dataIndex: 'code',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'IMO',
      dataIndex: 'imo',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Embarcação',
      dataIndex: 'vessel_name',
      render: (value, record) => {
        return (
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{ width: '20px' }}>
              {record.vessel_flag && (
                <ErrorBoundary replace="">
                  <Flag code={record.vessel_flag} size="m" />
                </ErrorBoundary>
              )}
            </div>
            <span
              style={{
                textTransform: 'capitalize',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              {value?.toLowerCase() || ''}
            </span>
          </div>
        );
      },
    },
    {
      title: 'Berço',
      dataIndex: 'place_name',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Agente de Navegação',
      dataIndex: 'shipping_agency_name',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Faturamento',
      dataIndex: 'charge_created_at',
      render: (value) => {
        return <div>{createDateStringPtBr(value)}</div>;
      },
    },
    {
      title: 'Processamento da Fatura',
      dataIndex: 'charge_update_at',
      render: (value) => {
        return <div>{createDateStringPtBr(value)}</div>;
      },
    },
    {
      title: 'Performance em Horas',
      dataIndex: 'diff_datetime',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Valor Total',
      dataIndex: 'total_value',
      render: (value) => {
        return (
          <div>
            {value?.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
        );
      },
    },
  ];
}
